import React from 'react'

import { useSearchParams } from 'wouter'

/**
 * It used to be that you'd include comma-separated `?debug=foo,bar` urls to
 * turn on and off debug values. If you do this, we can re-write it to the
 * "native" form with duplicate keys `?debug=foo&debug=bar` once on app boot
 */
export function NormalizeDebugParams() {
  const [searchParams, setSearchParams] = useSearchParams()

  React.useEffect(() => {
    const debugValues = searchParams.getAll('debug')
    if (!debugValues.some((value) => value.includes(','))) return

    setSearchParams(
      (params) => {
        const normalized = debugValues
          .flatMap((value) => value.split(','))
          .map((value) => value.trim())
          .filter(Boolean)
        params.delete('debug')
        for (const value of normalized) params.append('debug', value)
        return params
      },
      { replace: true },
    )
  }, [searchParams, setSearchParams])

  return null
}
